export default "__VITE_ASSET__a298e362__"